module.exports = __webpack_public_path__ + "static/media/PF.4ad99843.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/PF.svg
// module id = 337
// module chunks = 0